export default "__VITE_ASSET__CvOMkVKF__"